class RelatedProducts extends HTMLElement {
    constructor() {
        super();
        this.url = "";
        this.section = null;
        this.sectionId = "";
    }

    connectedCallback() {
        this.init();
    }

    async init() {
        this.section = this;
        this.url = this.dataset.url;
        this.sectionId = this.id;

        if (!this.url || !this.sectionId) {
            console.warn("Missing data-url or data-id on <related-products>");
            return;
        }

        try {
            const recommendationsHTML = await this.fetchRecommendations(this.url);
            if (recommendationsHTML) {
                this.section.innerHTML = recommendationsHTML;
                this.initSlider();
            }
        } catch (error) {
            console.error("Failed to fetch recommendations:", error);
        }
    }

    async fetchRecommendations(url) {
        try {
            const response = await fetch(url);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");
            const recommendations = doc.getElementById(this.sectionId);
            return recommendations?.innerHTML.trim() || null;
        } catch (error) {
            console.error("Error fetching product recommendations:", error);
            return null;
        }
    }

    initSlider() {
        try {
            new Swiper(`.mySwiper--${this.sectionId}`, {
                speed: 1000,
                slidesPerView: "auto",
                // loop: true,
                freeMode: true,
                spaceBetween: 20,
                grabCursor: true,
                // loopPreventsSliding: false,
                navigation: {
                    nextEl: ".custom-btn-next",
                    prevEl: ".custom-btn-prev",
                },
            });
        } catch (error) {
            console.error("Swiper init error:", error);
        }
    }
}

customElements.define("related-products", RelatedProducts);
